export default {
  siteName: "AllChinaBuy Spreadsheet",
  siteTagline: "Trouvez de meilleurs produits, comparez les options et achetez plus intelligemment",
  navHome: "Accueil",
  navCategories: "Catégories",
  navGuides: "Guides",
  navShipping: "Livraison",
  navReviews: "Avis",
  navSafety: "Sécurité",
  navComparisons: "Comparaisons",
  navBlog: "Blog",
  navFaq: "FAQ",
  navAbout: "À propos",
  navContact: "Contact",
  navProducts: "Produits",
  ctaMain: "Explorer le Spreadsheet",
  ctaBuyNow: "Achetez maintenant",
  ctaGuide: "Lire le guide",
  ctaVisitMain: "Visiter le site principal",
  trustIndependent: "Ressource indépendante",
  trustUpdated: "Guides mis à jour",
  trustLanguages: "4 Langues",
  heroTitle: "AllChinaBuy Spreadsheet — Trouvez de meilleurs produits, comparez les options et achetez plus intelligemment",
  heroSubtitle: "Explorez les ressources AllChinaBuy spreadsheet, les découvertes de produits, les guides des vendeurs, les conseils QC, les informations de livraison, les avis et les conseils pratiques d'achat — tout en un seul endroit.",
  heroCtaPrimary: "Explorer le AllChinaBuy Spreadsheet",
  heroCtaSecondary: "Commencer le guide du débutant",
  sectionWhatIs: "Qu'est-ce que le AllChinaBuy Spreadsheet ?",
  sectionWhatIsDesc: "Le AllChinaBuy spreadsheet est une ressource organisée qui aide les acheteurs à découvrir des produits de qualité, à comparer les vendeurs et à prendre des décisions d'achat éclairées. Il regroupe les découvertes de produits, les avis et les conseils d'achat en un seul hub.",
  sectionCategories: "Catégories populaires du Spreadsheet",
  sectionHowItWorks: "Comment fonctionne le Spreadsheet",
  sectionHowItWorksStep1: "Parcourez les catégories ou recherchez des produits",
  sectionHowItWorksStep2: "Comparez les vendeurs, les prix et les détails QC",
  sectionHowItWorksStep3: "Suivez les guides d'achat et les conseils de sécurité",
  sectionHowItWorksStep4: "Achetez en toute confiance via des liens de confiance",
  sectionReview: "Avis AllChinaBuy",
  sectionReviewDesc: "Un avis indépendant et honnête de la plateforme AllChinaBuy couvrant la livraison, le QC, les frais, les services d'entrepôt et l'expérience utilisateur globale. Mise à jour régulièrement avec des insights réels.",
  sectionShipping: "Guide des coûts de livraison",
  sectionShippingDesc: "Comprendre comment les coûts de livraison sont calculés en fonction du poids, de la destination, de la taille du colis, de la ligne de livraison et des facteurs saisonniers. Apprenez à économiser sur la livraison avec les options de consolidation et d'assurance.",
  sectionWarehouse: "Entrepôt & QC",
  sectionWarehouseDesc: "Découvrez comment fonctionne le processus d'entrepôt AllChinaBuy : de la livraison du vendeur à l'inspection QC, l'approbation, la consolidation et l'expédition finale du colis. Connaissances essentielles pour chaque acheteur.",
  sectionSafety: "Centre de sécurité",
  sectionSafetyDesc: "Vérifiez les URLs, consultez les évaluations des vendeurs, inspectez les photos QC et suivez les pratiques de paiement sécurisées. Nos guides de sécurité vous aident à éviter les arnaques et à acheter en confiance.",
  sectionComparison: "AllChinaBuy vs Concurrents",
  sectionComparisonDesc: "Comparez AllChinaBuy avec Superbuy, CSSBuy et Sugargoo. Voyez les différences en termes de frais, livraison, QC, services d'entrepôt et expérience utilisateur pour trouver le meilleur agent pour vos besoins.",
  sectionArticles: "Derniers guides et articles",
  sectionFaq: "Questions fréquemment posées",
  finalCtaTitle: "Prêt à explorer le AllChinaBuy spreadsheet ?",
  finalCtaDesc: "Commencez avec les dernières ressources spreadsheet, guides et informations d'achat.",
  footerAbout: "À propos",
  footerPolicy: "Politique éditoriale",
  footerDisclaimer: "Avertissement",
  footerPrivacy: "Politique de confidentialité",
  footerTerms: "Conditions",
  footerContact: "Contact",
  readMore: "Lire la suite",
  learnMore: "En savoir plus",
  lastUpdated: "Dernière mise à jour",
  relatedArticles: "Articles connexes",
  tableFeature: "Fonctionnalité",
  tableAllChinaBuy: "AllChinaBuy",
  tableSuperbuy: "Superbuy",
  tableCSSBuy: "CSSBuy",
  tableSugargoo: "Sugargoo",
  categoryShoes: "Chaussures",
  categorySneakers: "Baskets",
  categoryHoodies: "Sweats à capuche/Pulls",
  categoryTShirts: "T-Shirts",
  categoryJackets: "Vestes",
  categoryPants: "Pantalons/Shorts",
  categoryHeadwear: "Couvre-chefs",
  categorySets: "Ensembles",
  categoryUnderwear: "Sous-vêtements",
  categoryJersey: "Maillots",
  categoryAccessories: "Accessoires",
  categoryBags: "Sacs",
  categoryBelts: "Ceintures",
  categoryPerfumes: "Parfums",
  categoryOther: "Autres",
  articleTitle1: "Guide AllChinaBuy Spreadsheet 2026 : Comment trouver les meilleurs produits",
  articleDesc1: "Un guide complet pour naviguer dans le AllChinaBuy spreadsheet, comprendre les catégories et trouver des produits de qualité avec des vendeurs vérifiés et des conseils QC.",
  articleTitle2: "AllChinaBuy est-il légitime ? Guide complet de sécurité et de confiance",
  articleDesc2: "Une évaluation indépendante de la légitimité d'AllChinaBuy, des pratiques de sécurité, de la protection des paiements et comment éviter les erreurs d'achat courantes.",
  articleTitle3: "AllChinaBuy vs Superbuy : Quel agent choisir ?",
  articleDesc3: "Une comparaison détaillée d'AllChinaBuy et Superbuy couvrant les frais, la livraison, le QC, les services d'entrepôt et l'expérience utilisateur globale.",
  faq1Q: "Qu'est-ce que le AllChinaBuy spreadsheet ?",
  faq1A: "Le AllChinaBuy spreadsheet est une collection organisée de découvertes de produits, d'informations sur les vendeurs et de conseils d'achat classés par catégorie. Il aide les acheteurs à découvrir des articles de qualité et à comparer les options avant d'acheter.",
  faq2Q: "AllChinaBuy est-il sûr à utiliser ?",
  faq2A: "AllChinaBuy est une plateforme d'agent d'achat légitime. Cependant, comme tout service d'achat international, les acheteurs doivent suivre des pratiques de sécurité : vérifier les évaluations des vendeurs, consulter les photos QC, utiliser des méthodes de paiement sécurisées et lire les avis avant d'acheter.",
  faq3Q: "Comment fonctionne la livraison avec AllChinaBuy ?",
  faq3A: "AllChinaBuy propose plusieurs lignes de livraison en fonction de la destination, du poids et de la taille du colis. Les coûts dépendent du poids réel ou volumétrique, du pays de destination et de la méthode de livraison choisie. Des options de consolidation et d'assurance sont disponibles.",
  faq4Q: "Puis-je faire confiance aux recommandations de produits du spreadsheet ?",
  faq4A: "Le spreadsheet est une ressource indépendante qui compile les découvertes et avis de la communauté. Bien que nous vérifions les informations au mieux de nos capacités, effectuez toujours vos propres contrôles QC et lisez les avis des vendeurs avant d'acheter.",
  faq5Q: "Qu'est-ce que le QC et pourquoi est-ce important ?",
  faq5A: "Le QC (contrôle qualité) est le processus d'inspection où le personnel de l'entrepôt vérifie vos articles pour détecter les défauts, les problèmes de taille ou les produits incorrects avant l'expédition. C'est crucial pour détecter les problèmes tôt et demander des échanges ou des remboursements.",
  pageNotFound: "Page non trouvée",
  pageNotFoundDesc: "La page que vous recherchez n'existe pas. Retournez à l'accueil pour explorer les ressources AllChinaBuy spreadsheet.",
  backToHome: "Retour à l'accueil",
  allchinabuySpreadsheet: "AllChinaBuy Spreadsheet",
  spreadsheetHub: "Hub Spreadsheet",
  comparison: "Comparaison",
  warehouse: "Entrepôt",
  review: "Avis",
  coupon: "Coupon",
  discountCode: "Code de réduction",
  legit: "Légitime",
  shippingCost: "Coût de livraison",
  beginnersGuide: "Guide du débutant",
  qcGuide: "Guide QC",
  sellerGuide: "Guide des vendeurs",
  buyingChecklist: "Liste de contrôle d'achat",
  productVerification: "Vérification des produits",
  safetyCenter: "Centre de sécurité",
  paymentSafety: "Sécurité des paiements",
  sellerSafety: "Sécurité des vendeurs",
  qcSafety: "Sécurité QC",
  shippingSafety: "Sécurité de livraison",
  scamWarning: "Alerte aux arnaques",
  alternatives: "Alternatives",
  vsSuperbuy: "AllChinaBuy vs Superbuy",
  vsCSSBuy: "AllChinaBuy vs CSSBuy",
  vsSugargoo: "AllChinaBuy vs Sugargoo",
  languageEnglish: "Anglais",
  languageFrench: "Français",
  languageDanish: "Danois",
  languageGerman: "Allemand",
  breadcrumbHome: "Accueil",
  editorialTitle: "Politique éditoriale",
  editorialDesc: "Ce site fournit des informations éducatives indépendantes et n'est pas affilié à AllChinaBuy. Nous ne garantissons pas la qualité des produits, la fiabilité des vendeurs ou les résultats de livraison. Vérifiez toujours les informations indépendamment.",
  cookieNotice: "Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre utilisation des cookies.",
  cookieAccept: "Accepter",
  productsTitle: "Catalogue de Produits",
  productsSubtitle: "Parcourez notre collection de produits vérifiés du spreadsheet AllChinaBuy. Cliquez sur un article pour voir les détails et acheter.",
  productsSearchPlaceholder: "Rechercher des produits...",
  allCategories: "Tous",
  noProductsFound: "Aucun produit trouvé.",
  buyNow: "Acheter",
};